module.exports = __webpack_public_path__ + "static/icons/icon-snow-ca9885fa5ba5df4ceb28d3696dc9a8c0.svg";